import React, { Component } from 'react';

class ChunkLoadErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null,
            isRefreshing: false 
        };
    }

    static getDerivedStateFromError(error) {
        // Check if this is a ChunkLoadError
        if (error.name === 'ChunkLoadError' || 
            error.message.includes('Loading chunk') || 
            error.message.includes('Failed to load resource')) {
            return { 
                hasError: true, 
                error: error 
            };
        }
        // For other errors, let the parent ErrorBoundary handle them
        return null;
    }

    componentDidCatch(error, errorInfo) {
        console.error('ChunkLoadError caught by boundary:', error, errorInfo);
        
        // Track the error for analytics
        if (window.gtag) {
            window.gtag('event', 'exception', {
                description: 'ChunkLoadError: ' + error.message,
                fatal: false
            });
        }
    }

    handleRefresh = () => {
        this.setState({ isRefreshing: true });
        
        // Clear any cached chunks
        if ('caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => {
                    if (name.includes('chunk') || name.includes('static')) {
                        caches.delete(name);
                    }
                });
            });
        }
        
        // Refresh the page
        window.location.reload();
    };

    handleDismiss = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl p-6 w-full max-w-md text-center shadow-xl">
                        <div className="text-6xl mb-4">🔄</div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">
                            App Update Available
                        </h2>
                        <p className="text-gray-600 mb-6">
                            A new version of KinsThread is available. Please refresh to get the latest features and improvements.
                        </p>
                        
                        <div className="space-y-3">
                            <button
                                onClick={this.handleRefresh}
                                disabled={this.state.isRefreshing}
                                className="w-full bg-green-500 text-white font-bold py-3 px-6 rounded-xl hover:bg-green-600 transition active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {this.state.isRefreshing ? (
                                    <div className="flex items-center justify-center">
                                        <svg className="animate-spin h-5 w-5 text-white mr-3" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Refreshing...
                                    </div>
                                ) : (
                                    'Refresh App'
                                )}
                            </button>
                            
                            <button
                                onClick={this.handleDismiss}
                                className="w-full text-gray-600 font-bold py-2 hover:text-gray-800 transition"
                            >
                                Continue Anyway
                            </button>
                        </div>
                        
                        <p className="text-xs text-gray-400 mt-4">
                            If the problem persists, try clearing your browser cache.
                        </p>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ChunkLoadErrorBoundary;


